import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { DividerStyled, AlertStyled, LinkStyled } from './ACHAlert.styles';

export default function ACHAlert({ handleNavigate = null }) {
  return (
    <AlertStyled>
      <Stack
        direction="row"
        spacing="16px"
      >
        <DividerStyled />
        <Stack spacing="4px">
          <Text
            size="lg"
            weight="medium"
          >
            <LinkStyled
              color="primary.dark"
              onClick={handleNavigate}
            >
              Need to send via ACH?
            </LinkStyled>
          </Text>
          <Text size="md">
            To send via ACH, you must first create a new payee account. You may keep this account
            active, or archive it.
          </Text>
        </Stack>
      </Stack>
    </AlertStyled>
  );
}

ACHAlert.propTypes = {
  handleNavigate: PropTypes.func
};
